module.exports = __webpack_public_path__ + "static/img/2189b4091efde86a.7a8fea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/2189b4091efde86a.jpg
// module id = eNXv
// module chunks = 1